/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetTaskQueryResponse, GetTaskPathParams, GetTask400, GetTask401, GetTask403, GetTask404, GetTask409, GetTask500 } from "../../types/planningTasksController/GetTask.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetTaskUrl(organizationId: GetTaskPathParams["organizationId"], taskId: GetTaskPathParams["taskId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/tasks/${taskId}` as const }
  return res
}

/**
 * @summary Get task by ID
 * {@link /api/organizations/:organizationId/tasks/:taskId}
 */
export async function getTask(organizationId: GetTaskPathParams["organizationId"], taskId: GetTaskPathParams["taskId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetTaskQueryResponse, ResponseErrorConfig<GetTask400 | GetTask401 | GetTask403 | GetTask404 | GetTask409 | GetTask500>, unknown>({ method : "GET", url : getGetTaskUrl(organizationId, taskId).url.toString(), ... requestConfig })
  return res.data
}